import { CompanyContactType } from '@api';
import { CompanyContactSelectValueType } from '../../types';

export const getContactSelectFieldValue = (
  value: CompanyContactSelectValueType | null,
  data: CompanyContactType[]
): string | null => {
  if (!value) return null;

  const selectedContactPerson = data.find(
    (contactPerson) =>
      contactPerson.personId === value.personId &&
      contactPerson.companyId === value.companyId
  );
  if (!selectedContactPerson) return null;

  return data.indexOf(selectedContactPerson).toString();
};
